import React from 'react';
import './DataTable.css';

const DataTable = () => {
  const users = [
    { id: 1, name: 'John Smith', email: 'john@example.com', status: 'active', joined: '2023-01-15' },
    { id: 2, name: 'Sarah Johnson', email: 'sarah@example.com', status: 'pending', joined: '2023-02-20' },
    { id: 3, name: 'Michael Brown', email: 'michael@example.com', status: 'active', joined: '2023-03-10' },
    { id: 4, name: 'Emily Davis', email: 'emily@example.com', status: 'inactive', joined: '2023-01-05' },
    { id: 5, name: 'Robert Wilson', email: 'robert@example.com', status: 'active', joined: '2023-04-18' },
  ];

  return (
    <div className="data-table-container">
      <div className="table-header">
        <h3 className="table-title">Recent Users</h3>
        <button className="view-all">View All</button>
      </div>
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Email</th>
            <th>Status</th>
            <th>Joined</th>
          </tr>
        </thead>
        <tbody>
          {users.map(user => (
            <tr key={user.id}>
              <td>{user.id}</td>
              <td>{user.name}</td>
              <td>{user.email}</td>
              <td><span className={`status ${user.status}`}>{user.status}</span></td>
              <td>{user.joined}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DataTable;